import { render, staticRenderFns } from "./bussetting-websocket.vue?vue&type=template&id=0a2abcc9&scoped=true&"
import script from "./bussetting-websocket.vue?vue&type=script&lang=js&"
export * from "./bussetting-websocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2abcc9",
  null
  
)

export default component.exports